import React, {useState, useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button, Dropdown} from 'react-bootstrap';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import * as actions from '../_redux/userDetailsActions';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import Empty from './Empty';
import PopupViewVersions from './PopupViewVersions';
import {useParams} from 'react-router-dom';
import PopupCloseForm6101 from './PopupCloseForm6101';
import PopupNewForm6101 from './PopupNewForm6101';
import PopupUploadForm101 from './PopupUploadForm101';
import PopupErrorMessage from './PopupErrorMessage';
import PopupDeleteFile from './PopupDeleteFile';
import {roundDate} from '../utils/roundDate';
import {ProtectedComponent} from '../../_common/components/Permissions';

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <Button
    variant={'light'}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={'files-dropdown-action'}
  >
    <img
      src={toAbsoluteUrl('/media/svg/three-dots-vertical_1.svg')}
      alt="download"
      className="files-dropdown-action-btn"
    />
  </Button>
));

const CustomDDItem = React.forwardRef(
  ({children, style, className, 'aria-labelledby': labeledBy}, ref) => (
    <label
      className={`${className} d-flex align-items-center cursor-pointer`}
      style={style}
      ref={ref}
    >
      {children}
    </label>
  )
);

export function Files({data = [], className}) {
  const dispatch = useDispatch();
  const user = useSelector(
    (state) => state.userDetails.user,
    shallowEqual
  );
  const [showGenerateFile, setShowGenerateFile] = useState(false);
  const openGenerateFile = () => setShowGenerateFile(true);
  const closeGenerateFile = () => setShowGenerateFile(false);

  const [showGenerateFileNew, setShowGenerateFileNew] = useState(false);
  const openGenerateFileNew = () => setShowGenerateFileNew(true);
  const closeGenerateFileNew = () => setShowGenerateFileNew(false);

  const [showUploadForm101, setShowUploadForm101] = useState(false);
  const openUploadForm101 = () => setShowUploadForm101(true);
  const closeUploadForm101 = () => setShowUploadForm101(false);

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessageCode, setErrorMessageCode] = useState(0);
  const openErrorMessage = () => setShowErrorMessage(true);
  const closeErrorMessage = () => setShowErrorMessage(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleGenerateFile = () => {
    const {_id: userID, email} = user;
    const selfEmployedEndDate = roundDate(selectedDate);
    dispatch(actions.generate6101({userID, selfEmployedEndDate, email}))
      .then(errorCode => {
        closeGenerateFile();
        if (errorCode < 0) {
          setErrorMessageCode(errorCode);
          openErrorMessage();
        } else {
          dispatch(actions.fetchUser({userId: userID}));
        }
      });
  };

  const handleGenerateFileNew = () => {
    const {_id: userID, email} = user;

    dispatch(actions.generate6101New({userID, email}))
      .then(errorCode => {
        closeGenerateFileNew();
        if (errorCode < 0) {
          setErrorMessageCode(errorCode);
          openErrorMessage();
        } else {
          dispatch(actions.fetchUser({userId: userID}));
        }
      });
  };

  const getFileById = ({id, name, extension}) => () => {
    dispatch(actions.getFile({id, name, extension}));
  };

  const userMongoId = useParams().userId;
  const uploadRef = useRef();
  const uploadAdjustmentTaxRef = useRef();

  const onUploadFileChange = (e) => {
    let file = e.target.files[0];
    if (Boolean(file)) {
      uploadFile(file, userMongoId)
        .then(() => uploadRef.current.value = null);
    }
  };

  const onChangeTaxAdjustment = (taxAdjustment) => (e) => {
    let file = e.target.files[0];
    if (Boolean(file)) {
      uploadFileTaxAdjustment(file, userMongoId, taxAdjustment)
        .then(() => uploadAdjustmentTaxRef.current.value = null);
    }
  };

  const uploadFile = async (file, userMongoId) => {
    const {email} = user;
    await dispatch(actions.uploadFile({userMongoId, file, email}))
      .then(() => {
        dispatch(actions.fetchUser({userId: userMongoId}));
      }).catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  const uploadFileTaxAdjustment = async (file, userMongoId, taxAdjustment) => {
    const {email} = user;
    await dispatch(actions.uploadFileTaxAdjustment({userMongoId, file, taxAdjustment, email}))
      .then(() => {
        dispatch(actions.fetchUser({userId: userMongoId}));
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  const mapFiles = file => {
    const {
      _id: id,
      file_name,
      file_section_text,
      file_extension,
      upload_time
    } = file;

    return (
      <div
        key={id}
        className={`mb-2 files-list ${className}`}
      >
        <div className="font-weight-bolder font-size-sm">
          {file_name}
        </div>
        <div className="font-size-sm">
          {file_section_text}
        </div>
        <div className="font-size-sm">
          {file_extension}
        </div>
        <div className="font-size-sm">
          {moment(upload_time).format('DD[/]MM[/]YYYY')}
        </div>
        <div className="font-size-sm d-flex align-items-center justify-content-center">
          <Button
            variant="outline-primary"
            className="d-flex align-items-center justify-content-between m-0 custom-button-primary"
            onClick={getFileById({
              id,
              name: file_name,
              extension: file_extension
            })}
          >
            <img
              src={toAbsoluteUrl('/media/svg/Download-blue.svg')}
              alt="download"
            />
          </Button>
        </div>
        <div className="font-size-sm d-flex align-items-center justify-content-center">
          <PopupViewVersions
            id={id}
            fileName={file_name}
            fileExtension={file_extension}
          />
        </div>
        <div className="font-size-sm d-flex align-items-center justify-content-center">
          <PopupDeleteFile
            fileName={file_name}
            fileMongoID={id}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={`card card-custom ${className}`}>
        <div
          className="card-header border-0 justify-content-between align-items-center flex-nowrap"
        >
          <div className="d-flex">
            <img
              src={toAbsoluteUrl('/media/svg/Selected-file-blue.svg')}
              className="mr-3"
              alt="file icon"
            />
            <h3 className="card-title font-weight-bolder text-dark">
              <FormattedMessage
                id="userDetails-files-title"
                defaultMessage="Files"
              />
            </h3>
          </div>
          <div className="d-flex align-center">
            <ProtectedComponent action="full" subject="userPage">
              <Dropdown>
                <Dropdown.Toggle
                  as={CustomToggle}
                  variant="light"
                  id="dropdown-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item as={CustomDDItem}>
                    <img
                      src={toAbsoluteUrl('/media/svg/Upload-blue.svg')}
                      alt="upload"
                      className="files-dropdown-action-img"
                    />
                    <span className={'ml-1'}>
                      <FormattedMessage
                        id="userDetails-files-upload-file"
                        defaultMessage="Upload file"
                      />
                    </span>
                    <input
                      type="file"
                      className="d-none"
                      id="uploadedFile"
                      onChange={onUploadFileChange}
                      onInput={e => console.log({target: e.target})}
                      ref={uploadRef}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item as={CustomDDItem}>
                    <img
                      src={toAbsoluteUrl('/media/svg/Upload-blue.svg')}
                      alt="upload"
                      className="files-dropdown-action-img"
                    />
                    <span className={'ml-1'}>
                      <FormattedMessage
                        id="userDetails-files-upload-file-raisingTax"
                        defaultMessage="Upload file"
                      />
                    </span>
                    <input
                      type="file"
                      className="d-none"
                      id="uploadedFile"
                      onChange={onChangeTaxAdjustment(1)}
                      ref={uploadAdjustmentTaxRef}
                    />
                  </Dropdown.Item>
                  <Dropdown.Item onClick={openUploadForm101}>
                    <div
                      className="d-flex justify-center align-items-center cursor-pointer media"
                    >
                      <img
                        src={toAbsoluteUrl('/media/svg/Upload-blue.svg')}
                        alt="upload"
                        className="files-dropdown-action-img"
                      />
                      <span className={'ml-1'}>
                      <FormattedMessage
                        id="userDetails-files-upload-form-101"
                        defaultMessage="Upload form 101"
                      />
                    </span>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={openGenerateFile}>
                    <div
                      className="d-flex justify-center align-items-center cursor-pointer media"
                    >
                      <img
                        src={toAbsoluteUrl('/media/svg/pdf.svg')}
                        alt="pdf"
                        className="files-dropdown-action-img"
                      />
                      <span className={'ml-1'}>
                      <FormattedMessage
                        id="userDetails-files-generate-pdf"
                        defaultMessage="Generate PDF"
                      />
                    </span>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={openGenerateFileNew}>
                    <div
                      className="d-flex justify-center align-items-center cursor-pointer media"
                    >
                      <img
                        src={toAbsoluteUrl('/media/svg/pdf.svg')}
                        alt="create"
                        className="files-dropdown-action-img"
                      />
                      <span className={'ml-1'}>
                      <FormattedMessage
                        id="userDetails-files-generate-pdf-new"
                        defaultMessage="Create PDF"
                      />
                    </span>
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ProtectedComponent>
          </div>
        </div>
        <div className="card-body pt-2">
          {
            (data.length === 0)
              ? <Empty/>
              : (
                <>
                  <div className="files-list mb-3" id="custom-brand-color-tableHead">
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-name"
                        defaultMessage="Name"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-section"
                        defaultMessage="Section"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-extension"
                        defaultMessage="Extension"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-uploaded"
                        defaultMessage="Uploaded"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-downloadBtn"
                        defaultMessage="Download"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-fileVersions"
                        defaultMessage="File versions"
                      />
                    </div>
                    <div className="font-weight-bolder">
                      <FormattedMessage
                        id="userDetails-files-column-deleteFile"
                        defaultMessage="Delete file"
                      />
                    </div>
                  </div>
                  {data.map(mapFiles)}
                </>
              )
          }
        </div>
      </div>
      <PopupCloseForm6101
        isOpen={showGenerateFile}
        onSubmit={handleGenerateFile}
        onDateSelect={setSelectedDate}
        onHide={closeGenerateFile}
      />
      <PopupNewForm6101
        isOpen={showGenerateFileNew}
        onSubmit={handleGenerateFileNew}
        onHide={closeGenerateFileNew}
      />
      <PopupUploadForm101
        isOpen={showUploadForm101}
        onHide={closeUploadForm101}
      />
      <PopupErrorMessage
        onHide={closeErrorMessage}
        isOpen={showErrorMessage}
        errorMessageCode={errorMessageCode}
      />
    </>
  );
}
